{
  "phone_numbers": ["+48-793-023-009"],
  "address": "ul. Jana III Sobieskiego 21/255-330 Lutynia",
  "nip": "8952121637",
  "email": "jervice24@gmail.com",
  "social": [
    {
      "id": 1,
      "icon": "/icons/instagram-icon.svg",
      "alt": "Instagram",
      "href": "https://www.instagram.com/jervice_auto"
    },
    {
      "id": 2,
      "icon": "/icons/youtube-icon.svg",
      "alt": "Youtube",
      "href": "https://www.youtube.com/@JerviceService"
    },
    {
      "id": 3,
      "icon": "/icons/facebook-icon.svg",
      "alt": "Facebook",
      "href": "https://www.facebook.com/people/Jervice-tw%C3%B3j-auto-serwis/61584503609694/"
    },
    {
      "id": 4,
      "icon": "/icons/tiktok-icon.svg",
      "alt": "TikTok",
      "href": "https://www.tiktok.com/@jervice_autoservice"
    }
  ]
}
